import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface QueryLoadingStateProps {
  label?: string;
  minHeight?: number | string;
}

const QueryLoadingState: React.FC<QueryLoadingStateProps> = ({
  label = 'Loading...',
  minHeight = 220,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={1.5}
      minHeight={minHeight}
      width="100%"
    >
      <CircularProgress size={36} />
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
};

export default QueryLoadingState;
